module.exports = __webpack_public_path__ + "images/choices/masthead@2x-6f44854462afa29a64933f22652753e1.png";